import React,  {Component} from 'react';
import Translation from '../General/Translation';

export default class Description extends Component {
    constructor (props) {
        super(props) 
        this.state = {
            descriptionOpen: false
        }

        this.toggleLongDescription = this.toggleLongDescription.bind(this)
    }

    componentDidUpdate(prevProps) {
        if(this.props.movieData.pk !== prevProps.movieData.pk) {
            this.setState({
                descriptionOpen: false
            })
        }
    }

    toggleLongDescription() {
        this.setState({
            descriptionOpen: !this.state.descriptionOpen
        })
    }

    
    render() {
        const { translation, movieData, className="text-large-medium" } = this.props
        const { descriptionShort, description } = movieData
        const { descriptionOpen } = this.state

        if(!description && !descriptionShort) {
            return ''
        } else if(description && !descriptionShort) {
            return <div className={'description ' + className} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: description}}></div>  
        } else if(!description && descriptionShort || descriptionShort.length === description.length) {
            return <div className={'description ' + className} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: descriptionShort}}></div>
        } else {
            return descriptionOpen ? (
                <div className='description'>
                    <span className={className} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: description}}></span>
                    <button className={'text-xlarge-bold cursor-pointer show-more-or-less-button'} onClick={() => this.toggleLongDescription()}> <Translation id="lessButton" trans={translation}>weniger</Translation></button>
                </div>
            ) : (
                <div className='description'>
                    <span className={className} style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: descriptionShort}}></span>
                    <button className={'text-xlarge-bold cursor-pointer show-more-or-less-button'} onClick={() => this.toggleLongDescription()}><Translation id="moreButton" trans={translation}>mehr</Translation></button>
                </div>
            )
        }
    }
}